(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dreizentia-bekleidung"] && !Shopify.designMode) return;
  try {
    
  const initDreizentiaCollectionFilters = (root) => {
    if (!root || root.dataset.dctReady === 'true') return;

    const filters = Array.from(root.querySelectorAll('[data-dct-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-dct-card]'));
    const count = root.querySelector('[data-dct-count]');
    const scroller = root.querySelector('.dct__tab-scroller');
    if (!filters.length || !cards.length) return;

    const updateScrollerEdge = () => {
      if (!scroller) return;
      const isAtEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 4;
      scroller.classList.toggle('is-at-end', isAtEnd);
    };

    const updateCount = (amount) => {
      if (!count) return;
      const label = amount === 1 ? root.dataset.dctItemLabel : root.dataset.dctItemsLabel;
      count.textContent = `${amount} ${label}`;
    };

    const applyFilter = (nextFilter) => {
      const handle = nextFilter.dataset.dctFilter;
      const showAll = handle === root.dataset.dctAll;
      let visibleCount = 0;

      filters.forEach((filter) => {
        const isActive = filter === nextFilter;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach((card) => {
        const handles = (card.dataset.dctCollections || '').split('|');
        const isVisible = showAll || handles.includes(handle);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      updateCount(visibleCount);
      if (window.matchMedia('(max-width: 749px)').matches) {
        nextFilter.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    };

    if (scroller) {
      scroller.addEventListener('scroll', updateScrollerEdge, { passive: true });
      window.addEventListener('resize', updateScrollerEdge, { passive: true });
      requestAnimationFrame(updateScrollerEdge);
    }

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        applyFilter(filter);
      });
    });

    root.dataset.dctReady = 'true';
  };

  const initAllDreizentiaCollectionFilters = (scope = document) => {
    if (scope.matches && scope.matches('[data-dct]')) initDreizentiaCollectionFilters(scope);
    scope.querySelectorAll('[data-dct]').forEach(initDreizentiaCollectionFilters);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllDreizentiaCollectionFilters());
  } else {
    initAllDreizentiaCollectionFilters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllDreizentiaCollectionFilters(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const selectedFilter = event.target.closest('[data-dct-filter]');
    if (selectedFilter) selectedFilter.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edelstahl-products"] && !Shopify.designMode) return;
  try {
    
  class EdelstahlFilter extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-steel-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-steel-card]'));
      this.count = this.querySelector('[data-visible-count]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.show(button));
      });
    }

    show(activeButton) {
      const category = activeButton.dataset.steelFilter;

      this.buttons.forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      this.cards.forEach((card) => {
        card.hidden = category !== 'all' && card.dataset.steelCategory !== category;
      });

      if (this.count && activeButton.dataset.countLabel) {
        this.count.textContent = activeButton.dataset.countLabel;
      }
    }
  }

  if (!customElements.get('edelstahl-filter')) {
    customElements.define('edelstahl-filter', EdelstahlFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
